import { useTranslations } from "@jugl-web/utils";
import { useMemo } from "react";
import { VoiceGender, VoiceStyle } from "../types";

export const useVoiceAttributeLabels = () => {
  const { t } = useTranslations();

  const genderLabels = useMemo<Record<VoiceGender, string>>(
    () => ({
      female: t({
        id: "client-support-page.voice-gender-female",
        defaultMessage: "Female",
      }),
      male: t({
        id: "client-support-page.voice-gender-male",
        defaultMessage: "Male",
      }),
    }),
    [t]
  );

  const styleLabels = useMemo<Record<VoiceStyle, string>>(
    () => ({
      bright: t({
        id: "client-support-page.voice-style-bright",
        defaultMessage: "Bright",
      }),
      firm: t({
        id: "client-support-page.voice-style-firm",
        defaultMessage: "Firm",
      }),
      "easy-going": t({
        id: "client-support-page.voice-style-easy-going",
        defaultMessage: "Easy-going",
      }),
      clear: t({
        id: "client-support-page.voice-style-clear",
        defaultMessage: "Clear",
      }),
      upbeat: t({
        id: "client-support-page.voice-style-upbeat",
        defaultMessage: "Upbeat",
      }),
      even: t({
        id: "client-support-page.voice-style-even",
        defaultMessage: "Even",
      }),
      friendly: t({
        id: "client-support-page.voice-style-friendly",
        defaultMessage: "Friendly",
      }),
      lively: t({
        id: "client-support-page.voice-style-lively",
        defaultMessage: "Lively",
      }),
      excitable: t({
        id: "client-support-page.voice-style-excitable",
        defaultMessage: "Excitable",
      }),
      breezy: t({
        id: "client-support-page.voice-style-breezy",
        defaultMessage: "Breezy",
      }),
      smooth: t({
        id: "client-support-page.voice-style-smooth",
        defaultMessage: "Smooth",
      }),
      gravelly: t({
        id: "client-support-page.voice-style-gravelly",
        defaultMessage: "Gravelly",
      }),
      soft: t({
        id: "client-support-page.voice-style-soft",
        defaultMessage: "Soft",
      }),
      mature: t({
        id: "client-support-page.voice-style-mature",
        defaultMessage: "Mature",
      }),
      casual: t({
        id: "client-support-page.voice-style-casual",
        defaultMessage: "Casual",
      }),
      knowledgeable: t({
        id: "client-support-page.voice-style-knowledgeable",
        defaultMessage: "Knowledgeable",
      }),
      informative: t({
        id: "client-support-page.voice-style-informative",
        defaultMessage: "Informative",
      }),
      youthful: t({
        id: "client-support-page.voice-style-youthful",
        defaultMessage: "Youthful",
      }),
      forward: t({
        id: "client-support-page.voice-style-forward",
        defaultMessage: "Forward",
      }),
      gentle: t({
        id: "client-support-page.voice-style-gentle",
        defaultMessage: "Gentle",
      }),
    }),
    [t]
  );

  return { genderLabels, styleLabels };
};
